import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllStaff } from '../../store/practice';
import './OurPractice.css'

function OurPractice() {
  const dispatch = useDispatch()
  const allStaff = useSelector(state => state.staff)
  const [loaded, setLoaded] = useState(false)

  let staffArr;

  useEffect(() => {
    dispatch(getAllStaff())
  }, [dispatch])

  useEffect(() => {
    if (staffArr){
      setLoaded(true)
    }
  }, [staffArr])

  if (allStaff) {
    staffArr = Object.values(allStaff)
  }
  function image(name) {
    if (!name) return '/static/images/stethoscope.jpeg'
    const key = String(name).trim().toLowerCase()
    if (key.includes('goldman')) return '/static/images/MGoldman.jpg'
    if (key.includes('korff')) return '/static/images/MKorff.jpg'
    if (key.includes('neuman') || key.includes('neuman-sunshine')) return '/static/images/DNeuman-Sunshine.jpg'
    if (key.includes('uyehara')) return '/static/images/AUyehara1.jpg'
    if (key.includes('wettengel')) return '/static/images/CMoughon.jpg'
    if (key.includes('britt')) return '/static/images/EBritt.jpg'
    return '/static/images/stethoscope.jpeg'
  }

  if (!staffArr){
    return null
  }
  function tagline(credential){
    if (credential === 'M.D.'){
      return "Physician"
    } else if (credential.includes('N.P')){
      return "Nurse Practitioner"
    }
  }

  return loaded && staffArr ? (
    <div className='practice-container'>
      {/* <h1>Our Practice</h1> */}
      <div className='practice-cards-container'>
        {staffArr.filter(employee => employee.display).map(employee => {
          return (
            <div key={employee.id} className='practice-card'>
              <div className='practice-image-container'>
                {(() => {
                  const src = image(employee.lastName);
                  const isErin = employee.lastName && String(employee.lastName).toLowerCase().includes('britt');
                  const imgClass = `practice-image${isErin ? ' zoom-out' : ''}`;
                  return <img src={src} alt='provider' className={imgClass} />;
                })()}
              </div>
              <div className='practice-card-text'>
                <h3>{tagline(employee.credentials)}</h3>
                <h1 className='practice-names'>
                  {employee.firstName} {employee.lastName}, {employee.credentials}
                </h1>
                <p className='practice-biography-text'>{employee.biography}</p>
              </div>
            </div>
          )
        })}
      </div>
      
</div>
  ) : (
    <div>
      <h1>Loading...</h1>
    </div>
  )
}
export default OurPractice